import React from 'react';
import PropTypes from 'prop-types';
import { useTranslate } from 'react-admin';

const TicketPaymentMethodField = ({ source, record = {} }) => {
    const translate = useTranslate();
    return (
        <span>{ translate(`resources.tickets.paymentMethod.${record[source]}`) } </span>
      );
};

TicketPaymentMethodField.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

export default TicketPaymentMethodField;
